import { ApiResponse } from "../types/responseType";
import customFetch from "../util/config/axiosConfig";
import { StaffAccessResponse } from "../types/schoolAccess";

const accessControllerApis = {
  // GET all
  getStaffAccess: async (
    userId: number,
    branchCode?: string,
  ): Promise<ApiResponse<StaffAccessResponse>> => {
    const response = await customFetch.get<ApiResponse<StaffAccessResponse>>(
      `/api/v1/access/${userId}`,
      {
        params: branchCode ? { branchCode } : {},
      },
    );

    return response.data;
  },
};

export default accessControllerApis;
